import { cn } from '@eombor/ui';

/**
 * Rasm tanlash tugmasi — ko'rinishi tugma, mohiyati `<input type="file">`.
 *
 * `<label>` ichidagi yashirin maydon ATAYLAB: tugmani bosib maydonni
 * dasturiy chaqirish (`input.click()`) iOS da ba'zan bloklanadi, `label`
 * esa brauzerning o'z mexanizmi va hamma joyda ishlaydi. Fokus halqasi ham
 * o'z-o'zidan to'g'ri joyda qoladi.
 *
 * Fayl BOSQICHDAN mustaqil: berish oqimi ham (`PhotoStep`), qabul oynasi
 * ham (`ReceiptDialog`) shu bitta tugmani ishlatadi. Ikki nusxa yozilsa,
 * `capture` yoki maydonni tozalash kabi nozik joylar bir kun ajralib
 * ketardi.
 */
export interface PhotoPickerProps {
  label: string;
  icon: React.ReactNode;
  /**
   * `environment` — telefonda DARHOL orqa kamera ochiladi.
   *
   * Jonli kamera (`getUserMedia`) ATAYLAB ishlatilmaydi: u faqat HTTPS da
   * yoki `localhost` da ishlaydi, tizim esa ichki tarmoqda `http://` va IP
   * bilan ochiladi — u yerda brauzer kamerani umuman bermaydi.
   */
  capture?: 'environment';
  /** Bir vaqtda bir nechta rasm — galereyadan tanlashda oddiy hol. */
  multiple?: boolean;
  disabled?: boolean;
  /** `primary` — oynadagi ASOSIY harakat (qabul qilishda "Suratga olish"). */
  tone?: 'default' | 'primary';
  onPick: (files: File[]) => void;
}

export const PhotoPicker = ({
  label,
  icon,
  capture,
  multiple = true,
  disabled = false,
  tone = 'default',
  onPick,
}: PhotoPickerProps) => (
  <label
    className={cn(
      'inline-flex h-11 items-center gap-2 rounded-[var(--radius-sm)] px-4',
      'text-sm font-medium transition-[border-color,background-color]',
      'duration-[var(--motion-fast)]',
      disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
      tone === 'primary'
        ? 'border border-accent bg-accent text-[var(--color-accent-contrast)] hover:bg-accent-strong focus-within:ring-2 focus-within:ring-accent/40'
        : 'border border-border bg-surface-2 text-text hover:border-border-strong focus-within:border-accent',
    )}
  >
    {icon}
    {label}
    <input
      type="file"
      accept="image/*"
      multiple={multiple}
      disabled={disabled}
      {...(capture === undefined ? {} : { capture })}
      aria-label={label}
      className="sr-only"
      onChange={(event) => {
        const files = [...(event.target.files ?? [])];
        if (files.length > 0) onPick(files);
        // Maydon TOZALANADI: aks holda bir xil faylni ikkinchi marta tanlash
        // `change` hodisasini umuman qo'zg'atmaydi.
        event.target.value = '';
      }}
    />
  </label>
);
